





























































import Vue from "vue";
import store from "@/store";
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";

export default Vue.extend({
  name: "ViewpointCreate",

  components: {},

  props: {
    // status: {
    //   type: String,
    //   default: 'ok',
    //   required: false,
    //   validator: (value) => {
    //     return [
    //       'ok',
    //       'loading',
    //       'syncing',
    //       'synced',
    //       'version-conflict',
    //       'error'
    //     ].indexOf(value) !== -1
    //   }
    // },
  },

  data() {
    return {
      valid: false,
      dialog: false,
      vp_updating: false,
      message: 'Your viewpoint is being created ...',
      showMessage: false,
      formSubject: '',
      ruleSubject: [
        (v: any) => !!v || '"Viewpoint Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Viewpoint Name" must be less than 100 characters'
      ],
      formBody: '',
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ]
    };
  },

  created() {},

  mounted() {
  },

  updated() {
    // console.log(this.$refs.form);
  },

  watch: {
    isUpdating(newVal, oldVal) {
      console.log("[ TEAM CREATE ]: oldVal-" + oldVal + " newVal-" + newVal);
      if (!newVal && oldVal && this.isError) {
        this.message = this.errorMessage + '<br />Please try again in a few minutes.';
        setTimeout(() => this.showMessage=false, 5000);
      } else if (!newVal && oldVal && !this.isError && this.showMessage) {
        this.showMessage = false;
        this.dialog = false;
        this.clearForm();
      }
    },
    dialog(newVal, oldVal) {
      if (!newVal) {
        this.clearForm();
      }
    },
    // routeName(newVal, oldVal) {
    //   if (newVal === 'mls') {
    //     this.showFavourites = false;
    //   }
    //   if (newVal === 'favourites') {
    //     this.showFavourites = true;
    //   }
    // },
  },

  computed: {
    isValid(): boolean {
      return (this.valid && !!this.formSubject);
    },
    isUpdating(): any {
      return this.$store.getters.getVpUpdating;
    },
    isError(): boolean {
      return !!this.$store.getters.getVpErrorMessage;
    },
    errorMessage(): string {
      return this.$store.getters.getVpErrorMessage;
    },
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },
    thisForm(): Vue & { reset: () => void } {
      return this.$refs.form as Vue & { reset: () => void };
    },
  },

  methods: {
    viewpointCreate() {
      if (this.formSubject) {
        this.message = 'Your Viewpoint is being created ...';
        this.showMessage = true;
        let body: any = {
          name: this.formSubject
        };
        if (this.formBody) {
          body.description = this.formBody;
        }
        store.dispatch("createViewpoint", body);
      }
    },

    clearForm(): void {
      this.thisForm.reset();
    },

  }
});
